import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
}

export default function ArticleCard({ slug, title, excerpt, coverImage, category, author, date, readTime }: ArticleCardProps) {
  return (
    <Link
      to={`/articles/${slug}`}
      className="group bg-background-50 rounded-2xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 block"
    >
      <div className="aspect-[16/9] overflow-hidden bg-background-100">
        <img
          src={coverImage}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">
            {category}
          </span>
          <span className="text-xs text-foreground-500">{readTime}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{author}</span>
          <span>{date}</span>
        </div>
      </div>
    </Link>
  );
}